<template>
	<page enable-flex>
		<view-list ref="view" work-type="14" :search="{scan: true}">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state color="#FF6900" type="tag">超卖</c-state>
					</template>

					<template #date>
						{{data.create_date}}
					</template>

					<template #state>
						<c-state dict="OVERSOLD_HANDLE_STATE" :value="data.handle_state" type="state"></c-state>
					</template>

					<template #areaTag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #areaName>
						{{data.product_name || '-'}}
					</template>

					<template #area>
						<c-field label="背贴码">{{data.produce_code || '-'}}</c-field>
						<c-field label="IMEI">{{data.imei || '-'}}</c-field>
						<c-field label="超卖渠道">{{data.confirm_channel_name || '-'}}</c-field>
						<c-field label="确认售出价"><span style="color: #FF6900;">{{formatPrice(data.confirm_sale_price)}}</span></c-field>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
			/*********格式化价格（待处理单无确认售出价，空值显示-，与PC端同口径）**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '￥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>